import _ from '../constants/gettext';

export default function handleGraphQlError(error) {
  let errors = error?.graphQLErrors?.map((e) => {
    return e.extensions.clientMessage;
  });

  if (!errors || errors.length === 0) {
    errors = [_('ERROR_CONTACT_SALES')];
  }

  return errors;
}
